(() => {
  "use strict";

  if (window.GuruDesignSystem?.disabledActionGuard) return;

  const selector = '.guru-button[aria-disabled="true"]';
  const isDisabledAction = (target) => target instanceof Element && target.closest(selector);

  const preventDisabledAction = (event) => {
    if (!isDisabledAction(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };

  const preventDisabledKeyboardAction = (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    preventDisabledAction(event);
  };

  document.addEventListener("click", preventDisabledAction, true);
  document.addEventListener("keydown", preventDisabledKeyboardAction, true);

  window.GuruDesignSystem = {
    ...(window.GuruDesignSystem || {}),
    disabledActionGuard: true,
  };
})();
